import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
// import styled from 'styled-components';
import anime from "animejs";

// const OpeningBackground = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   width: 100%;
//   height: 200%;
//   background-color: #ffffff;
//   z-index: 1030;
//   transform: skewY(160deg) translate(0%, -20%);
//   opacity: 0.9;
// `;

@withRouter
export default class ScrollToTop extends PureComponent {
  constructor(props) {
    super(props);
    this.obRef = React.createRef();
  }
  componentDidMount() {
    // window.scrollTo(0, 0);
    setTimeout(() => {
      this.init();
    }, 100);
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.init();
    }
  }
  init = () => {
    // this.doAnimate();
    // window.scrollTo(0, 0);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  doAnimate = () => {
    anime({
      targets: this.obRef.current,
      skewY: ["160deg", "160deg"],
      translateY: ["-20%", "150%"],
      duration: 7000,
      delay: 200,
      easing: "easeOutExpo",
      opacity: [0.9, 0],
    });
  };
  render() {
    return (
      <React.Fragment>
        {this.props.children}
        {/* <OpeningBackground innerRef={this.obRef} /> */}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js